import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, ShieldWarning } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Control admin: ¿este entorno puede ESCRIBIR (stock/precios/envíos) en la tienda? */
export default function TNPushControl({ status, onChanged }) {
  const { user } = useAuth();
  const [saving, setSaving] = useState(false);
  if (!status?.connected) return null;
  const enabled = status.push_enabled !== false;
  const explicit = status.push_enabled_explicit;
  const preview = !!status.is_preview_env;

  const setMode = async (value) => {
    const msg = value === true
      ? "¿Permitir que ESTE entorno escriba stock y precios en la tienda? Si otro entorno (ej. producción) también sincroniza, se van a pisar entre sí."
      : value === false
        ? "¿Bloquear la escritura en la tienda desde este entorno? Se seguirán leyendo ventas, pero no se empujará stock ni precios."
        : "¿Volver al modo automático? (bloqueado en preview, habilitado en producción)";
    if (!window.confirm(msg)) return;
    setSaving(true);
    try {
      await api.put("/tiendanube/push-config", { stock_push_enabled: value });
      toast.success("Configuración de escritura actualizada");
      onChanged?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className={`mb-4 rounded-sm border px-3 py-2 flex items-center gap-3 flex-wrap text-[12px] ${enabled ? "border-emerald-300 bg-emerald-50/60 text-emerald-900" : "border-red-300 bg-red-50 text-red-900"}`}
      data-testid="tn-push-control"
    >
      {enabled ? <ShieldCheck size={18} weight="fill" className="text-emerald-600" /> : <ShieldWarning size={18} weight="fill" className="text-red-600" />}
      <div className="flex-1 min-w-[260px]">
        <div className="font-semibold">
          {enabled ? "Este entorno ESCRIBE en la tienda (stock, precios, envíos)." : "Este entorno NO escribe en la tienda (sólo lee ventas)."}
        </div>
        <div className="text-[11px] opacity-80">
          Entorno detectado: <b>{preview ? "PREVIEW / prueba" : "producción"}</b> · Modo: <b>{explicit === null || explicit === undefined ? "automático" : explicit ? "forzado ON" : "forzado OFF"}</b>.
          Dos entornos escribiendo a la vez se pisan el stock entre sí (ej. 9999 → 0 → 9999).
        </div>
      </div>
      {user?.is_admin && (
        <div className="flex items-center gap-1">
          <button type="button" disabled={saving} onClick={() => setMode(null)} data-testid="tn-push-auto"
            className={`px-2 py-1 rounded-sm border text-[11px] font-mono ${explicit == null ? "bg-neutral-800 text-white border-neutral-800" : "bg-white border-neutral-300"}`}>Auto</button>
          <button type="button" disabled={saving} onClick={() => setMode(true)} data-testid="tn-push-on"
            className={`px-2 py-1 rounded-sm border text-[11px] font-mono ${explicit === true ? "bg-emerald-700 text-white border-emerald-700" : "bg-white border-neutral-300"}`}>Permitir</button>
          <button type="button" disabled={saving} onClick={() => setMode(false)} data-testid="tn-push-off"
            className={`px-2 py-1 rounded-sm border text-[11px] font-mono ${explicit === false ? "bg-red-700 text-white border-red-700" : "bg-white border-neutral-300"}`}>Bloquear</button>
        </div>
      )}
    </div>
  );
}
